// extracted by mini-css-extract-plugin
export var bodySections = "_c8-8";
export var gray = "_c8-7";
export var green = "_c8-4";
export var iconContainer = "_c8-9";
export var iconWidgetContainer = "_c8-1";
export var phoneIcon = "_c8-2";
export var red = "_c8-5";
export var statusDot = "_c8-3";
export var widgetContainer = "_c8-0";
export var yellow = "_c8-6";